import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React, { useRef, useState } from "react";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin } from "../../../models/Login";
import { MailSending } from "./MailSending";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { POCForm } from "./POCForm";

interface IPOCs {
    id?: number,
    pocName?: string,
    pocEmail?: string,
    createdAt?: Date,
}

interface IProps {
    singleData: IPOCs[],
    open: boolean,
    hideDialog: () => void,
    job: any,
    toast: any,
}

export const LeadPOCs = (props: IProps) => {
    const [openEmailModel, setOpenEmailModel] = useState({ open: false, emailTO: {} } as { open: boolean, emailTO: IPOCs });
    const [modal, setModal] = useState({ singleData: {}, open: false } as { open: boolean, singleData: any });

    const dt = useRef<any>(null);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const onHide = () => {
        props.hideDialog();
    }

    const confirmSendMail = (rowData: any) => {
        confirmDialog({
            message: `Are you sure you want to send an email to ${rowData.pocName}?`,
            header: 'Send Email Confirmation',
            icon: 'pi pi-envelope',
            acceptClassName: 'p-button-success',
            rejectClassName: 'p-button-secondary',
            acceptLabel: 'Yes, Send',
            rejectLabel: 'Cancel',
            accept: () => setOpenEmailModel({ open: true, emailTO: rowData }),
            reject: () => props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })
        });
    };

    const openNew = () => {
        setModal({ open: true, singleData: {} });
    };

    const sendCompanyDetail = (rowData: any) => {
        return (
            <>
                <Button icon="pi pi-envelope" className="p-button-rounded  p-button-text ml-2" onClick={() => confirmSendMail(rowData)} tooltip="Send an email to this POC" />
            </>
        )
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const DateFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="POC's" modal className="p-fluid" onHide={onHide}>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines resizableColumns scrollable scrollHeight="65vh"
                value={props.singleData || []}
                emptyMessage="No Recrods found."
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="pocName" header="Name" />
                <Column field="pocEmail" header="Email" />
                <Column field="createdAt" header="Created At" body={(rowData: IPOCs) => safeFormatDate(new Date(rowData?.createdAt || "").toDateString(), "dd/MM/yyyy", DateFormat)} />
                <Column field="" header="Send Email" body={sendCompanyDetail} />
            </DataTable>
            <ConfirmDialog />
            {/* <MailSending open={openEmailModel.open} emailTO={openEmailModel.emailTO} job={props.job} hideDialog={() => setOpenEmailModel({ open: false, emailTO: {} })} toast={props.toast} /> */}
            <POCForm open={modal.open} jobDetails={props.job || {}} singleData={modal.singleData} hideDialog={() => setModal({ open: false, singleData: {} })} toast={props.toast} />
        </Dialog>
    );
}